import { IUserApiClient } from '@cyber-range/cyber-range-api-user-client';
import { useAuthenticationStore } from '../../stores/authenticationStore';
import { useApiClientStore } from '../../stores/apiClientStore';

export default abstract class UserCreator
{
    constructor() {}

    async getSsoToken(): Promise<string>
    {
        return await useAuthenticationStore().getSsoToken();
    }

    get userApiClient(): IUserApiClient
    {
        return useApiClientStore().backgroundUserApiClient;
    }
}
